import { getImage, railProxy } from '@dazn/lp-web/src/utils';
import { buttonProxy } from '@dazn/lp-web/src/proxies/button.proxy';
import { ComponentTypes } from '@dazn/lp-web/src/constants/componentTypes.constants';
import { IButton, IImage, ISpotlightRail } from '@dazn/lp-web/src/types';

export function spotlightRailProxy(
    component: any,
    spotlightRail?: any
): ISpotlightRail | null {
    if (spotlightRail) {
        const rail = spotlightRail
            ? railProxy(spotlightRail, ComponentTypes.SPOTLIGHT_RAIL)
            : null;

        return {
            ...component,
            tiles: rail?.tiles ?? []
        };
    }

    const componentType = component?.fields?.componentType;
    const railId = component?.fields?.railId;
    const railParams = component?.fields?.railParams;
    const title = component?.fields?.title;
    const description = component?.fields?.description;

    let button = {} as IButton;
    let image = {} as IImage;
    component?.fields?.entries?.forEach(({ fields, sys }: any) => {
        if (sys?.contentType?.sys?.id === 'LPButton') {
            button = buttonProxy(fields);
        }
        if (sys?.contentType?.sys?.id === 'AdaptiveImage') {
            image = getImage({ fields });
        }
    });

    if (!railId) {
        return null;
    }

    return {
        title,
        railId,
        button,
        image,
        tiles: [],
        description,
        railType: componentType,
        componentType,
        railParams
    };
}
